import {Injectable, ViewChild} from '@angular/core';
import {timer, Subscription} from 'rxjs';
import {OverlayPanel} from 'primeng/overlaypanel';
import {FcJsEvent} from './fc-js-event';
import {environment} from 'projects/desktop/src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CalendarEventTipService {

  eventHintOP: OverlayPanel

  eventHintShown = false;
  eventHintShowSubs: Subscription;
  eventHintHideSubs: Subscription;


  constructor() {
  }

  showHint(eventInfo: FcJsEvent, cls: string = 'event-shortcode') {
    // TODO: make class member
    const t = environment.defaultEventShowHintDelay;
    if (this.eventHintShown) {
      if (this.eventHintHideSubs) {
        this.eventHintHideSubs.unsubscribe()
      }
    }

    this.eventHintShowSubs = timer(t).subscribe(() => {
      if (eventInfo.el.getElementsByClassName(cls)[0]) {
        this.eventHintShown = true;
        this.eventHintOP.show(eventInfo.jsEvent, eventInfo.el.getElementsByClassName(cls)[0])
      }
      // this.eventHintOP.show(eventInfo.jsEvent, eventInfo.el.getElementsByClassName('event-title')[0])
    })

  }

  hideHint() {
    if (this.eventHintShowSubs) {
      this.eventHintShowSubs.unsubscribe()
    }
    this.eventHintOP.hide()
    this.eventHintHideSubs = timer(environment.defaultEventHideHintDelay).subscribe(() => {
      this.eventHintShown = false;
    })
  }
}
